<template>
  <StageScaler>
    <OnboardingStage data-testid="onboarding-stage" :targets="$store.getters['branding/currentTargets']" />
  </StageScaler>
</template>

<script>
import { OnboardingStage } from '@goldcast/uicomponents-branding';

import StageScaler from './StageScaler.vue';

export default {
  name: 'OnboardingStagePreview',
  components: { OnboardingStage, StageScaler }
};
</script>
